import axios from 'axios';

export const FETCH_ARTICLES = 'FETCH_ARTICLES';
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_BOOKS = 'FETCH_BOOKS';

export function fetchArticlesDispatch() {
	return ( dispatch ) => {
		'use strict';
		const url = `${ ISDA_Membership.isda_articles_endpoint_url }`;

		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_ARTICLES, payload: response.data
			          } );
		} );
	};
}

export function fetchEventsDispatch() {
	return ( dispatch ) => {
		'use strict';
		const url = `${ ISDA_Membership.isda_events_endpoint_url }`;

		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_EVENTS, payload: response.data
			          } );
		} );
	};
}

export function fetchBooksDispatch() {
	return ( dispatch ) => {
		'use strict';
		const url = `${ ISDA_Membership.isda_books_endpoint_url }`;

		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_BOOKS, payload: response.data
			          } );
		} );
	};
}